import React from 'react';
import { Button, Tag } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

type Props = React.ComponentProps<typeof Button> & {
  label?: string;
};

export default function PillButton({ label = 'Quick apply', className = '', ...props }: Props) {
  return (
    <Tag
      {...props}
      className={[
        'h-11 px-5 !rounded-full inline-flex items-center gap-2 border-none',
        'bg-[#F4EEFF] text-[#6A35F4]',
        'hover:!bg-[#EFE8FF] active:scale-[.98] transition-all',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#CBB6FF]/60',
        className,
      ].join(' ')}>
      <span className="font-medium">{label}</span>
      <span className="flex items-center justify-center h-8 w-8 rounded-full bg-[#EDE3FF]">
        <CheckOutlined className="text-[#6A35F4] text-[16px]" />
      </span>
    </Tag>
  );
}
